import { render, staticRenderFns } from "./topDescription.vue?vue&type=template&id=504acd96&scoped=true&"
import script from "./topDescription.vue?vue&type=script&lang=js&"
export * from "./topDescription.vue?vue&type=script&lang=js&"
import style0 from "./topDescription.vue?vue&type=style&index=0&id=504acd96&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "504acd96",
  null
  
)

export default component.exports